import { render } from "./VillasFilter.vue?vue&type=template&id=753bbc33"
import script from "./VillasFilter.vue?vue&type=script&lang=js"
export * from "./VillasFilter.vue?vue&type=script&lang=js"
script.render = render

export default script